import React from 'react';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import { InputErrorContainer } from '../../error/containers/input-error.container';

export function CheckboxInputComponent({
  label,
  name,
  value,
  onValueChange,
  isDisabled,
  error,
  className,
  onClick,
  isRequired,
}: any) {

  return (
    <div
      className={`${className} mb-3 input-wrapper-overrider`}
      onClick={(event) => onClick && onClick(event)}
    >
      <InputLabelContainer isRequired={isRequired} label={label} />

      <input
        type="checkbox"
        checked={value || false}
        className={` w-5 h-5 ${className}`}
        disabled={isDisabled}
        name={name}
        onChange={onValueChange}
        required={isRequired}
      />

      <InputErrorContainer error={error} />
    </div>
  );
}